import React, { useContext, useEffect, useState } from "react";
import maincss from './MainCSS.module.css';
import Cookies from 'js-cookie';
import axios from "axios";
import Header from "./Header";
import { urlContext } from "./UrlContext";

const Client = () => {

    const clientSn = {sn: Cookies.get('sn')};
    const [showClient, setShowClient] = useState();
    const [showClientPayment, setShowClientPayment] = useState();
    const [editCont, setEditCont] = useState();
    const [editState, setEditState] = useState(false);

    const { baseurl } = useContext(urlContext);

    const url = baseurl + "/getClient.php";
    const url2 = baseurl + "/getClientPayments.php";
    const url4 = baseurl + "/getClient.php";

    const activateClient = (event) => {
        event.preventDefault();

        const url3 = baseurl + "/activateClient.php";

        axios
            .post(url3, clientSn)
            .then((response) => {
                if (response.data === "Done") {
                    alert("Activated!");
                } else {
                    alert("Failed! Already activated for the current month");
                }
            }).catch((err) => {
                console.log(err);
            })
    }

    const editClient = (event) => {
        event.preventDefault();
            setEditState(true);
    }

    const [formData, setFormData] = useState({
        clientname: "",
        accountno: "",
        phoneno: "",
        amount: "",
        router: "",
        ip: "",
        sn: Cookies.get('sn'),
    });

    const handleFormChange = (event) => {
        const {name, value} = event.target;
        setFormData({...formData, [name]: value})
        console.log(formData);
    };

useEffect(() => {
    axios
    .post(url4, clientSn)
    .then((response) => {
        const data = response.data.map(function (row) {
            return (
                <fieldset key={row}>
                    <legend>{row.clientname} Information</legend>
                    <label htmlFor="clientname">Client Name</label>
                    <input type="text" name="clientname" defaultValue={row.clientname} required onChange={handleFormChange} />
                    <label htmlFor="accountno">Account No</label>
                    <input type="text" name="accountno" defaultValue={row.accountno} required onChange={handleFormChange} />
                    <label htmlFor="phoneno">Phone No</label>
                    <input type="text" name="phoneno" defaultValue={row.phoneno} required onChange={handleFormChange} />
                    <label htmlFor="amount">Amount</label>
                    <input type="text" name="amount" defaultValue={row.amount} required onChange={handleFormChange} />
                    <label htmlFor="router">Router</label>
                    <select name='router' defaultValue={row.router} required onChange={handleFormChange}>
                        <option value="MIKROTIK 71">MIKROTIK 71</option>
                        <option value="FIBERLINK">FIBERLINK</option>
                    </select>
                    <label htmlFor="ip">Ip</label>
                    <input type="text" name="ip" defaultValue={row.ip} required onChange={handleFormChange} />
                </fieldset>
            )
        });
        setEditCont(data);
    }).catch((err) => {
        console.log(err);
    })
})

    axios
        .post(url, clientSn)
        .then((response) => {
            const data = response.data.map(function (row) {
                return (
                    <div key={row.sn}>
                        <h1>{row.clientname}</h1>
                        <p>Account Number: <b>{row.accountno}</b></p>
                        <p>Phone Number: <b>{row.phoneno}</b></p>
                        <p>Monthly Amount: <b>{row.amount}</b></p>
                        <p>Router: <b>{row.router}</b></p>
                        <p>Ip: <b>{row.ip}</b></p>
                        <p>Status: <b>{row.clientstatus}</b></p>
                        <p>Date Added: <b>{row.dateadded}</b></p>
                        <div className={maincss.btn} onClick={activateClient}>Activate</div>
                        <div className={maincss.btnedit} onClick={editClient}>Edit Client</div>
                    </div>
                )
            })
            setShowClient(data);
        }).catch((err) => {
            console.log(err);
        })

    
    axios
        .post(url2, clientSn)
        .then((response) => {
            const data2 = response.data.map(function (row) {
                return (
                    <tr key={row.id}>
                        <td>{row.amount}</td>
                        <td>{row.paydate}</td>
                        <td>{row.paymonth}</td>
                    </tr>
                )
            })
            setShowClientPayment(data2);
        }).catch((err) => {
            console.log(err);
        })

        const submitForm = (event) => {
            event.preventDefault();

            const url5 = baseurl + "/editClient.php";
            
            axios
                .post(url5, formData)
                .then((response) => {
                    console.log(response.data);
                    if (response.data === "posted") {
                        alert("Client Edited!");
                    } else {
                        alert("Unsuccessfull");
                    }
                }).catch((error) => {
                    console.log(error);
                });

            setEditState(false);
        };

        const handleHide = () => {
            setEditState(false);
        }

    return (
        <div>
            <Header />
            <div className={maincss.content}>
                {showClient}
                <div>
                    <h2>Payment History</h2>
                    <table>
                        <tr>
                            <th>Amount</th>
                            <th>Pay Date</th>
                            <th>Pay Month</th>
                        </tr>
                        {showClientPayment}
                    </table>
                </div>
            </div>
            <div className={maincss.popup} style={{display : editState ? "block" : "none"}} >
                <form onSubmit={submitForm} className={maincss.addClientForm}>
                    <h1>Edit Client</h1>
                    {editCont}
                    <button>Submit</button>
                    <div className={maincss.btnCancel} onClick={handleHide}>Cancel</div>
                </form>
            </div>
        </div>
    );
}

export default Client;